import { gql } from '@apollo/client';
const ASSIGN_PRODUCT_TO_COMPONENT = gql `
  mutation AssignProductToComponent($componentId: ID!, $productId: ID!) {
    assignProductToComponent(componentId: $componentId, productId: $productId) {
      component {
        id
        modelSpecification {
          id
          estimatedCostCalculationBlocked
          confirmationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
          estimatedCostCalculationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
        }
        hasOneVariantColorForAllSpecificationColors
        variantColorForAllSpecificationColors
        colors {
          edges {
            node {
              id
            }
          }
        }
        hasOneVariantSizeForAllSpecificationSizes
        variantSizeForAllSpecificationSizes
        sizes {
          edges {
            node {
              id
            }
          }
        }
        productSnapshot {
          id
          name
          productDescription
          supplierFullName
          supplierShortName
          width
          componentSize
          composition
          zipperType
          grammage
          producerCode
          underSliderType
          upperSliderType
          yardage
          image
          product {
            id
            name
            status
            pictures {
              edges {
                node {
                  id
                  image
                }
              }
            }
            zipperType {
              id
              name
              upperSlider
              underSlider
            }
            grammage {
              id
              name
            }
            componentSize {
              id
              name
            }
            width {
              id
              name
            }
            composition {
              id
              name
            }
            producerCode {
              id
              name
            }
            underSliderType {
              id
              name
            }
            upperSliderType {
              id
              name
            }
            yardage {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export default ASSIGN_PRODUCT_TO_COMPONENT;
